export default "__VITE_ASSET__BsDllMXK__"